import api from '../../api';

/**
 * Convertir les timeSlots du calendrier en leadPlanning par user
 */
export const convertTimeSlotsToLeadPlanningByUser = (timeSlots) => {
  const leadPlanningByUser = {};

  timeSlots.forEach(slot => {
    const { day, startTime, endTime, calendrier, distributions, source } = slot;

    distributions.forEach(dist => {
      const { userId, percentage } = dist;

      if (!leadPlanningByUser[userId]) {
        leadPlanningByUser[userId] = [];
      }

      leadPlanningByUser[userId].push({
        calendrier,
        percentage,
        day,
        start: startTime,
        end: endTime,
        ...(source ? { source } : {}),
      });
    });
  });

  return leadPlanningByUser;
};

/**
 * Comparer deux leadPlanning pour détecter les changements
 */
const hasLeadPlanningChanged = (oldPlanning = [], newPlanning = []) => {
  if (oldPlanning.length !== newPlanning.length) {
    return true;
  }

  const createKey = (p) =>
    `${p.calendrier}|${p.day}|${p.start}|${p.end}|${p.percentage}`;

  const oldSet = new Set(oldPlanning.map(createKey));

  return newPlanning.some(p => !oldSet.has(createKey(p)));
};

/**
 * Sauvegarder les timeSlots en mettant à jour le
 * leadPlanning des commerciaux concernés
 */
export const saveTimeSlots = async (timeSlots, commerciaux, source = null) => {
  const leadPlanningByUser = convertTimeSlotsToLeadPlanningByUser(timeSlots);

  const updatedLeadPlanningByUser = {};
  let hasChanges = false;

  commerciaux.forEach(commercial => {
    const userId = commercial._id;
    const newLeadPlanning = leadPlanningByUser[userId] || [];
    const oldLeadPlanning = commercial.leadPlanning || [];

    if (hasLeadPlanningChanged(oldLeadPlanning, newLeadPlanning)) {
      updatedLeadPlanningByUser[userId] = newLeadPlanning;
      hasChanges = true;
    }
  });

  if (!hasChanges) {
    return { success: true, updated: 0 };
  }

  const response = await api.users
    .custom('updateBulkLeadPlannings')
    .post({ leadPlanningByUser: updatedLeadPlanningByUser, source });

  return response.body().data();
};

/**
 * Charger les commerciaux et leurs timeSlots
 */
export const loadCommerciauxWithTimeSlots = async (source = null) => {
  const query = source
    ? `leadPlanningTimeSlots?source=${encodeURIComponent(source)}`
    : 'leadPlanningTimeSlots';
  const response = await api.users.custom(query).get();
  const {
    commerciaux,
    timeSlots,
    isReadOnly
  } = response.body().data();

  return {
    commerciaux,
    timeSlots,
    isReadOnly: isReadOnly || false
  };
};

/**
 * Réattribuer les demandes d'un slot spécifique
 */
export const reassignSlotLeads = async (userId, slot) => {
  const response = await api.users
    .custom(`reassignLeads/${userId}`)
    .post({ slot });

  return response.body().data();
};

/**
 * Déclencher manuellement la synchronisation avec Cal.com
 */
export const syncLeadPlanningsToCalcom = async () => {
  const response = await api.custom('leadPlanning/sync').post();
  return response.body().data();
};